import { useJwtUser } from "./useJwtUser";

/**
 * Helper hook to check if the current user is a support user.
 */
export const useIsSupport = () => {
  const jwtClaims = useJwtUser();

  /*
  Old SSO super user claim is "custom:granular_super_admin".
  0: Super reader
  1: Super user
  */
  const hasCognitoClaim =
    jwtClaims?.["custom:granular_super_admin"] !== undefined;
  /*
  Old SSO B2C implementation exposes the tassel group via the "granular_ad_groups" claim.
  */
  const hasB2CClaim =
    jwtClaims?.granular_ad_groups?.includes("fsd-pd-tassel-users") ?? false;
  /*
  New SSO defines user roles in the "roles" claim. These are populated based on the user's group membership, in this case "fsd-pd-tassel-users".
  */
  const hasNewSsoClaim = jwtClaims?.roles?.includes("support") ?? false;

  return hasCognitoClaim || hasB2CClaim || hasNewSsoClaim;
};
